import React, { FC, useEffect, useRef } from 'react'
import { ModalComponent } from 'Pages/landings/common/components/Modal'
import { DadataIpAddress, Region, Callback } from 'Pages/landings/common/types'
import { landingApi } from 'Pages/landings/common/api'
import { RegionModalComponent } from './modal'
import './style.scss'

export interface RegionAutoSelectProps {
	className?: string
	region?: Region
	setRegion: (reg: Region) => void
	isShowModal: boolean
	setIsShowModal: Callback
}

const { getRegions, getIp, getDadataAddressByIp } = landingApi

export const RegionAutoSelectComponent: FC<RegionAutoSelectProps> = ({
	className,
	setRegion,
	region,
	isShowModal,
	setIsShowModal,
}) => {
	const regionList = useRef<Region[]>([])

	useEffect(() => {
		const mainCallBack = (regions: Region[]) => {
			regionList.current = regions
			if (!region) {
				getIp()
					.then(getDadataAddressByIp)
					.then((address: DadataIpAddress) => {
						const nameRegion = address.location?.data.region || ''
						const nameRegionType = address.location?.data.region_type_full || ''
						const name = `${nameRegion} ${nameRegionType}`.toLocaleLowerCase().trim()
						const findRegion = regions.find((region) => region.name.toLocaleLowerCase() === name)

						if (findRegion) {
							setRegion(findRegion)
						} else {
							setIsShowModal()
						}
					})
					.catch(setIsShowModal)
			}
		}
		getRegions().then((response) => {
			if (response?.entries) mainCallBack(response.entries)
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const selectedRegion = region?.name || 'РЕГИОН НЕ ВЫБРАН'

	return (
		<>
			{isShowModal && (
				<ModalComponent closeModal={setIsShowModal}>
					<RegionModalComponent
						regions={regionList.current}
						setRegion={setRegion}
						regionAutoDetection={region}
						setIsShowModal={setIsShowModal}
					/>
				</ModalComponent>
			)}
			<div onClick={() => setIsShowModal()}>
				<div className={className}>
					<span className="landing-menu_right_item_icon-wrapper">
						<img src="../img/landing/navigation.svg" alt="navigation" />
					</span>
					{selectedRegion}
				</div>
			</div>
		</>
	)
}
